import { gql, useMutation } from '@apollo/client';

import type { UpdateDependantMutation, UpdateDependantMutationVariables } from './__generated__/useUpdateDependant.gql';

const UPDATE_DEPENDANT = gql`
  mutation UpdateDependant($input: UpdateDependantInput!) {
    updateDependant(input: $input) {
      id
      firstName
      lastName
      preferredName
      dateOfBirth
    }
  }
`;

/**
 * Updates an existing `Dependant` row. Apollo's normalized cache merges the
 * returned fields by `(Dependant, id)` so any consumer of the same dependant
 * picks up the new values without a manual refetch. Used by
 * `DependantEntryStep` in edit mode.
 */
export const useUpdateDependant = () => {
  return useMutation<UpdateDependantMutation, UpdateDependantMutationVariables>(UPDATE_DEPENDANT);
};
